import "../../../../../../controllers/physicians/show/profile_map.js";
import "../../../base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Views ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal ??= {};

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.Provider = class Provider extends (
  AppointmentBooking.SlotSuggester.Views.Base
) {
  static {
    this.prototype.tagName = "div";
    this.prototype.template = "reselector/suggestion_selector/confirmation_modal/provider";
    this.prototype.className = "sp-provider-card__content";
  }

  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    super.render(...arguments);

    const mapContainer = this.$el.find('[data-behaviour="sp-provider-card-map-container"]');
    if (mapContainer.length) {
      new Sparkle.Views.PhysicianProfileMap({ el: mapContainer, collection: [this.model.get("address")] });
    }

    return this;
  }
};
